module.exports = __webpack_public_path__ + "static/media/1001423DO.b97805d0.jpg";